import { FC, useState } from 'react';
import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem, Stack } from '@mui/material';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';
import Img from '@barracuda/shared/components/Primitive/Img';
import {
  navbarMenuItemButton,
  navbarMenuItemContent,
  navbarMenuItemElement,
  navbarMenuItemTitle,
  navbarMenuItemTitleTextBox,
  navbarMenuSubItemTypography
} from './NavbarMenuItem.styles';
import ArrowUp from '@/assets/images/menu__arrow-up.svg';
import ArrowDown from '@/assets/images/menu__arrow-down.svg';

interface NavbarMenuProps {
  title: string;
  items: NavbarMenuItem[];
}

export interface NavbarMenuItem {
  icon: string | JSX.Element;
  title: string;
  link: string;
  target?: string;
}

export const NavbarMenuItem: FC<NavbarMenuProps> = ({ title, items }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useLocalizedNavigate();
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleTitleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleItemClick = (item: NavbarMenuItem) => {
    setAnchorEl(null);

    if (item.target === '_blank') {
      window.open(item.link, '_blank');
    } else {
      navigate(item.link);
    }
  };

  return (
    <Stack>
      <Button sx={navbarMenuItemTitle(open)} onClick={handleTitleClick}>
        <Box sx={navbarMenuItemButton}>
          <Box>{title}</Box>
          <Img src={open ? ArrowUp : ArrowDown} />
        </Box>
      </Button>
      <Menu
        sx={navbarMenuItemContent}
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {items.map((item, index) => (
          <MenuItem
            key={`menu-item-${index}`}
            sx={navbarMenuItemElement}
            onClick={() => handleItemClick(item)}
          >
            <ListItemIcon>
              {typeof item.icon === 'string' ? <Img src={item.icon} /> : item.icon}
            </ListItemIcon>

            <ListItemText primaryTypographyProps={navbarMenuSubItemTypography}>
              <Box sx={navbarMenuItemTitleTextBox}>{item.title}</Box>
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};
